import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ContentChildren, OnInit, QueryList } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { concatMap } from 'rxjs/operators';
import { PaginationComponent } from 'src/app/components/elements/pagination/pagination.component';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { AccountantRequest } from 'src/app/models/company.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { UserNitResponse } from 'src/app/models/user.model';
import { AssociateCompanyService } from 'src/app/services/associate.service';
import { CompanyService } from 'src/app/services/company.service';
import { QueryParamsService } from 'src/app/services/query-params.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-inpartner',
  templateUrl: './inpartner.component.html',
  styleUrls: ['./inpartner.component.scss']
})
export class InpartnerComponent implements OnInit {
  associateCompanies = [];
  comissionCompanies = [];
  tab = '1';
  possibleNits: UserNitResponse[] = [];
  newAccountant: AccountantRequest = new AccountantRequest();
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  invalidEmail = false;

  constructor(
    private toastService: ToastrService,
    private associateService: AssociateCompanyService,
    private userService: UserService,
    private queryParamsService: QueryParamsService
  ) {
    for (let i = 0; i < 10; i++) {
      this.associateCompanies.push({ id: i, nit: '3455434' + i, name: 'nombre ' + i });
      this.comissionCompanies.push({ id: i, nit: '3455434' + i, name: 'nombre ' + i, total: 3 * i, comission: 2 * i });
    }
  }

  ngOnInit(): void {
    this.tab = this.queryParamsService.getStringParam("tab", '1');
  }

  updateIndexParam(value: any) {
    if (value==this.tab) {
      return;
    }
    this.queryParamsService.setParams({
      tab: value,
    });
  }

  refresh(pagination) {
    pagination.startElement = pagination.pageIndex * pagination.pageSize;
    var temporalLast = pagination.startElement + pagination.pageSize;
    pagination.lastElement = (temporalLast < pagination.total.length) ? temporalLast : pagination.total.length;
    pagination.filter = pagination.total.slice(pagination.startElement, pagination.lastElement);
  }

  saveAccountant() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    this.userService.createAccountant(this.newAccountant).subscribe({
      next: (response: ResponseObject) => {
        this.buttonSave.loading = false;
        this.newAccountant = new AccountantRequest();
        this.toastService.success("Se ha creado exitosamente el contador!")
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  validateEmail() {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.invalidEmail = !emailRegex.test(this.newAccountant.mail);
  }

}
